import Header from "../Home/Header";
import Blogpost from "./Blogpost";
import Fight_Hard from "./Fight_Hard";
import Plan from "./Plan";
import Testimonial from "./Testimonial";

const About = () => {
  return (
    <>
      <div className="w-full pt-30">
        <div className="p-0 flex items-center overflow-hidden min-h-[75vh]">
          <div className="container mx-auto px-10">
            <div className="flex flex-wrap items-center -mx-2 text-left">
              <div className="w-full lg:w-6/12 px-4 relative">
                <h1 className="text-4xl font-bold leading-tight from-[#a200be] to-[#246BFD] bg-gradient-to-tl  bg-clip-text text-transparent">
                  Connect with us, speed your TMS Systems
                </h1>
                <p className="mt-4 mb-4 text-xl leading-relaxed text-gray-400">
                  We aim high at being focused on building relationships with
                  our clients and community. Using our creative gifts drives
                  this foundation.
                </p>
                <div className="flex flex-wrap -mx-4 mt-8">
                  <div className="w-full sm:w-8/12 px-4 pr-2 relative">
                    <div className="mb-3 pt-0">
                      <input
                        type="email"
                        placeholder="Your email here"
                        className="w-full px-3 py-2 text-sm text-gray-700 placeholder-gray-400 bg-white border border-gray-300 rounded-md outline-none transition duration-200 focus:ring focus:ring-blue-400 focus:border-blue-400"
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-4/12 px-4 pl-0 relative">
                    <button className="w-full sm:w-auto px-6 py-2 text-sm font-bold uppercase text-white bg-pink-500 border border-pink-500 rounded-md shadow hover:shadow-lg transition duration-150 ease-in-out active:bg-pink-600 active:border-pink-600">
                      Join us
                    </button>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-6/12 px-4 relative">
                <img
                  src={"/assets/development.svg"}
                  alt="Illustration"
                  className="w-full lg:ml-12"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fight_Hard />
      <Blogpost />

      <Testimonial />
    </>
  );
};
export default About;
